module.exports = __webpack_public_path__ + "img/waitThai.236a9a1b.png";